import type {
	Page,
	IssueTypeScreenScheme,
	ScreenScheme,
	Screen,
	ProjectBean,
	WorkflowTransitions,
} from './types';

export const DEFAULT_PAGE_SIZE = 12;
export const DEFAULT_ASSOCIATIONS_DISPLAY_COUNT = 6;

export const FILTER_CHANGE_ANALYTICS = Object.freeze({
	ACTION: 'changed',
	ACTION_SUBJECT: 'filterSearch',
});

export const EMPTY_PAGE: Page<IssueTypeScreenScheme | ScreenScheme | Screen> = {
	startAt: 0,
	maxResults: 10,
	values: [],
	total: 0,
	isLast: true,
};
export const EMPTY_PROJECTS_PAGE: Page<ProjectBean> = {
	startAt: 0,
	maxResults: 10,
	values: [],
	total: 0,
	isLast: true,
};

export const EMPTY_WORKFLOWS_PAGE: Page<WorkflowTransitions> = {
	startAt: 0,
	maxResults: 10,
	values: [],
	total: 0,
	isLast: true,
};
